/** sessionStorage key for last user activity timestamp (ms since epoch). */
export const ADMIN_SESSION_LAST_ACTIVITY_KEY = "ns-admin-session-last-activity";

export function getAdminSessionLastActivity(): number {
  try {
    const raw = sessionStorage.getItem(ADMIN_SESSION_LAST_ACTIVITY_KEY);
    if (!raw) {
      return 0;
    }
    const parsed = Number.parseInt(raw, 10);
    return Number.isFinite(parsed) ? parsed : 0;
  } catch {
    return 0;
  }
}

export function touchAdminSessionActivity(at = Date.now()): void {
  try {
    sessionStorage.setItem(ADMIN_SESSION_LAST_ACTIVITY_KEY, String(at));
  } catch {
    /* private mode / quota */
  }
}

export function clearAdminSessionActivity(): void {
  try {
    sessionStorage.removeItem(ADMIN_SESSION_LAST_ACTIVITY_KEY);
  } catch {
    /* noop */
  }
}

export function getAdminSessionIdleMs(now = Date.now()): number {
  const last = getAdminSessionLastActivity();
  if (last <= 0) {
    return 0;
  }
  return Math.max(0, now - last);
}
